export function effectActiveItem(
	activeIndex: number,
	isSliderExpanded: boolean,
	hasNavigation: boolean,
	setActiveItem: (item: number) => void,
	moveSliderToIndex: (item: number) => void,
) {
	if (isSliderExpanded) return;
	if (!hasNavigation) return;
	if (activeIndex === -1) return;
	setActiveItem(activeIndex);
	moveSliderToIndex(activeIndex);
}
